import { pslClient } from "@/common/http-common";
import { API_URL_PROPERTY_LOOKUP } from "@/constants/api.constants.js";

class PropertyService {
  propertyLookup(data, config) {
    return pslClient.post(API_URL_PROPERTY_LOOKUP, data, config).then((res) => {
      return res.data;
    });
  }
}

export default new PropertyService();
